export enum KycStatus
{
    Incomplete = 0,
    Pending = 1,
    Rejected = 2,
    InProgress = 3,
    Complete = 4,
    Suspended = 5
}